"use client"
import { useRef, HTMLProps } from "react";
import { createSearchStore, SearchContext } from "@/store/search";
import SearchMain from "./components/SearchMain";

interface SearchProps extends HTMLProps<HTMLDivElement> {
	onInputChange?: (value: boolean) => void;
	onFocusChange?: (value: boolean) => void;
}

export default function Search({
	onInputChange,
	onFocusChange,
	...props
} : SearchProps) {
	const searchStore = useRef(createSearchStore()).current;
	
	return (
		<SearchContext.Provider
			value={searchStore}
		>
			<SearchMain
				onInputChange={onInputChange}
				onFocusChange={onFocusChange}
				{...props}
			/>
		</SearchContext.Provider>
	)
}
